import { render } from "./VideoBox.vue?vue&type=template&id=7433ca3e"
import script from "./VideoBox.vue?vue&type=script&lang=js"
export * from "./VideoBox.vue?vue&type=script&lang=js"

import "./VideoBox.vue?vue&type=style&index=0&id=7433ca3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__